import {
  computed,
  inject,
  Injectable,
  signal,
  WritableSignal,
} from '@angular/core';
import { User } from '../../../../auth/interfaces/user-interface';
import { BASE_URL } from '../../../../app.constants';
import { AuthService } from '../../../../auth/services/auth.service';
import { Menu } from '../interface/menu-interface';
import { Subscription, tap } from 'rxjs';
import { AuthHttpService } from '../../../services/auth-http.service';

@Injectable({
  providedIn: 'root',
})
export class SideBarMenuService {
  private http = inject(AuthHttpService);
  private authService = inject(AuthService);

  private _menuData: WritableSignal<Menu[]> = signal([]);
  public menuData = computed<Menu[]>(() => {
    return this._menuData();
  });

  private menuSubscription: Subscription | undefined;

  getMenu() {
    let user = this.authService.getUser();
    if (user != null) {
      this.menuSubscription = this.observerGetMenu(user).subscribe({
        next: (data) => {
          data.menus.forEach((menu: Menu) => {
            if (menu.subMenu) {
              menu.expanded = false;
            }
          });
          this._menuData.set(data.menus);
        },
        error: (error) => {
          if (error && error.codigo === 202) {
            this.authService.logout();
          }
        },
      });
    } else {
      this.authService.logout();
    }
  }

  ngOnDestroy() {
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }

  private observerGetMenu(user: User) {
    return this.http.post(`${BASE_URL}Acceso/getMenu`, user);
  }
}
